<script setup lang="ts">
import Header from '@/layouts/header/ColorHeader.vue';
import Footer from '@/layouts/footer/nftFooter.vue';
import Introduction from '@/components/pages/workers/Introduction.vue';
import BusinessCulture from '@/components/pages/workers/BusinessCulture.vue';
import WorkerNewsletter from '@/components/pages/workers/WorkerNewsletter.vue';
</script>
<template>
    <!--Header-->
    <Header />
    <Introduction />
    <BusinessCulture />
    <WorkerNewsletter />
    <Footer />
</template>
